import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import useIsFeatureEnabled from '../hooks/useIsFeatureEnabled';
import useIsLabFeatureEnabled from '../hooks/useIsLabFeatureEnabled';

import styles from '../styles/intellumAiCta.module.scss';

const GradientLibraryIcon = ({ children }) => (
  <>
    <svg width={0} height={0}>
      <linearGradient id="linearColors" x1={1} y1={0} x2={1} y2={1}>
        <stop offset={0} stopColor="rgb(var(--ids-color-ai-1-rgb))" />
        <stop offset={1} stopColor="rgb(var(--ids-color-ai-2-rgb))" />
      </linearGradient>
    </svg>
    {children}
  </>
);

const IntellumAiCta = ({
  body = '',
  hasIntellumTutorAPILoaded = false,
  openChat = () => {},
  redirectToUpNext = false,
  title = '',
}) => {
  const isFeatureEnabled = useIsFeatureEnabled('LEA-4864-course_recommendations');
  const isPersonalizedLearningEnabled = useIsLabFeatureEnabled('learning_plans', true);

  if (!isFeatureEnabled || !isPersonalizedLearningEnabled) return null;

  const handleClick = () => {
    if (redirectToUpNext && window.location.pathname !== '/student/my_learning/up_next') {
      window.location.href = '/student/my_learning/up_next?start_ai=true';
      return;
    }

    openChat();
  };

  return (
    <div className={styles.element}>
      <div>
        <div className={styles.left}>
          <div className={styles.myLearningIcon}>
            <GradientLibraryIcon>
              <LocalLibraryOutlinedIcon sx={{ fill: 'url(#linearColors)' }} />
            </GradientLibraryIcon>
          </div>
          <div>
            <Typo className={styles.text} element="p" weight="medium" variant="b02">
              {title}
            </Typo>
            <Typo className={styles.text} element="p" variant="s02">
              {body}
            </Typo>
          </div>
        </div>
      </div>
      <div>
        <Button
          type="ai"
          size="small"
          className={styles.button}
          variant="outlined"
          onClick={handleClick}
          isDisabled={!hasIntellumTutorAPILoaded && !redirectToUpNext}
        >
          {i18n.t('suggest-whats-next')}
        </Button>
      </div>
    </div>
  );
};

IntellumAiCta.propTypes = {
  body: PropTypes.string,
  hasIntellumTutorAPILoaded: PropTypes.bool,
  openChat: PropTypes.func,
  redirectToUpNext: PropTypes.bool,
  title: PropTypes.string,
};

export default IntellumAiCta;
